import { Turbo } from "@hotwired/turbo-rails"

Turbo.config.forms.confirm = async (message, element, submitter) => {
  const sourceEl = element.closest(".modal.show")
  const sourceModal = sourceEl && window.bootstrap.Modal.getOrCreateInstance(sourceEl)

  if (sourceModal) {
    submitter?.blur()
    if (sourceEl.dataset.modalReady === "false") {
      await new Promise((resolve) => {
        sourceEl.addEventListener("shown.bs.modal", resolve, { once: true })
      })
    }
    await new Promise((resolve) => {
      sourceEl.addEventListener("hidden.bs.modal", resolve, { once: true })
      sourceModal.hide()
    })
  }

  return new Promise((resolve) => {
    const modalEl = document.getElementById("confirm-modal")
    modalEl.querySelector("[data-confirm-message]").textContent = message
    const submit = modalEl.querySelector("[data-confirm-submit]")
    const action = element.dataset.confirmAction || "Delete"
    submit.textContent = action
    submit.className = `btn btn-${action === "Archive" ? "warning" : "danger"}`
    modalEl.dataset.modalReady = "false"

    const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl)
    const controller = new AbortController()
    let confirmed = false

    modalEl.querySelector("[data-confirm-submit]").addEventListener(
      "click",
      () => { confirmed = true; modal.hide() },
      { signal: controller.signal }
    )

    modalEl.addEventListener(
      "shown.bs.modal",
      () => { modalEl.dataset.modalReady = "true" },
      { signal: controller.signal }
    )

    modalEl.addEventListener(
      "hide.bs.modal",
      () => {
        modalEl.dataset.modalReady = "false"
        if (modalEl.contains(document.activeElement)) document.activeElement.blur()
      },
      { signal: controller.signal }
    )

    modalEl.addEventListener(
      "hidden.bs.modal",
      () => {
        if (!confirmed && sourceModal) {
          sourceEl.addEventListener("shown.bs.modal", () => submitter?.focus(), { once: true })
          sourceModal.show()
        }
        resolve(confirmed)
        controller.abort()
      },
      { signal: controller.signal }
    )

    modal.show()
  })
}
